export default function ReportHelper() {
  const base = [
    { name: "Jan" },
    { name: "Fev" },
    { name: "Mar" },
    { name: "Abr" },
    { name: "Mai" },
    { name: "Jun" },
    { name: "Jul" },
    { name: "Aug" },
    { name: "Set" },
    { name: "Out" },
    { name: "Nov" },
    { name: "Dez" },
  ];

  const monthNames = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const colors = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FFA07A",
    "#FF00D6",
    "#079D49",
    "#FFDB92",
    "#FFC145",
  ];

  return {
    base,
    monthNames,
    colors,
  };
}
